import { render, staticRenderFns } from "./CustomerCorporateExport.vue?vue&type=template&id=f9c36cda&scoped=true"
import script from "./CustomerCorporateExport.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c36cda",
  null
  
)

export default component.exports